//creazione delle checkbox per la toc
import React from 'react';
import { useEffect } from "react";
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import {changeCheckBox} from '../../../../redux'

const CheckBoxLayer = (props) => {
  
  const [state, setState] = React.useState(
           props.nodes.visible,
          
  );
  const handleChange = (event) => {
    
    
    props.selectCheckBox(props.nodes)
    
    
    //if(props.nodes.visible === true){console.log("MATTEO")}
    
    
    setState(event.target.checked);
    
  }; 
  useEffect(()=>{
    
      setState(props.nodes.visible);
     
  })/* ,[props.nodes.visible])  */ 

   
  return(<div>
            <Checkbox checked={state}   onChange={handleChange}   />
            
          </div>)
}


const mapStateToProps = state => {
  
  return {
      tocCheckBox: state.tocCheckBox
      
  }
}
const mapDispatchToProps = dispatch => {
  
  return {
    selectCheckBox: (checkBox) => dispatch(changeCheckBox(checkBox))
    
  }
  
}
export default connect(mapStateToProps,mapDispatchToProps) (CheckBoxLayer);